// #region imports
import * as React from 'react';

// Material-UI
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import LiveHelp from '@mui/icons-material/LiveHelp';
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip';

import {
  TransferablePassAction,
  TransferablePassStatus
} from '../../global';

// #endregion

// #region interfaces

interface PassesToolbarProps {
  handleStatusChange: (action: TransferablePassAction) => void;
  // Change this to match your new state shape
  passesSelected: {
    type: string;
    ids: Set<number>;
  };
}

// #endregion

const PassesToolbar: React.FC<PassesToolbarProps> = (props) => {

  const [action, setAction] = React.useState<TransferablePassAction>(TransferablePassAction.Confirm);

  // #region Event handlers

  /*
   * Handle toolbar action change
   */
  const handleActionChanged = (event: React.MouseEvent<HTMLElement>, a: TransferablePassAction) => {
    if (a !== null) {
      setAction(a);
    }
  };

  /*
   * Handle passes status change
   */
  const handleStatusChange = () => {
    props.handleStatusChange(action);
  };

  React.useEffect(() => {
    if (props.passesSelected.ids.size === 0) {
      setAction(TransferablePassAction.Confirm);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.passesSelected]);

  // #endregion

  return (
    <>
      <Grid>
        <ToggleButtonGroup
          disabled={props.passesSelected.ids.size === 0}
          value={action}
          exclusive
          onChange={handleActionChanged}
        >
          <ToggleButton value={TransferablePassStatus.Denied}>
            <Tooltip title="Deny">
              <BlockIcon />
            </Tooltip>
          </ToggleButton>
          <ToggleButton value={TransferablePassStatus.Requested}>
            <Tooltip title="Requested">
              <LiveHelp />
            </Tooltip>
          </ToggleButton>
          <ToggleButton value={TransferablePassStatus.Confirmed}>
            <Tooltip title="Confirmed">
              <CheckCircleIcon />
            </Tooltip>
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
      <Grid>
        <Tooltip title="Approve the status change for selected passes">
          <span>
            <IconButton
              disabled={props.passesSelected.ids.size === 0}
              onClick={handleStatusChange}
              size="large"
            >
              <PlaylistPlayIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Grid>
    </>
  );

}

export default PassesToolbar;